import { environment } from './platform'

const keycloakConfig = {
  url: environment === 'production' ? 'https://amei.sebrae.com.br/auth' : 'https://amei.homolog.kubernetes.sebrae.com.br/auth',
  realm: 'externo',
  clientId: 'prix-tech',
} as const

export default keycloakConfig
